import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const PolizzeConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/polizze/:id?',
      component: FuseLoadable({
        loader: () => import('./Polizze')
      })
    }
  ]
}
